import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ashcorp-meta',
    templateUrl: './meta.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AshcorpMetaComponent {
    @Input() meta: any = null;
    @Input() title = 'Info';
}
